const appendHeaders = () => {
    const cookies = document.cookie

    const xsrfCookie = cookies.split(';').find((cookie) => {
        const [cookieName] = cookie.split('=')
        return cookieName.trim() === '__amlexa_cc__csrf'
    })
    if (!xsrfCookie) {
        return {
            'Content-Type': 'multipart/form-data',
        }
    }

    const [, cookieValue] = xsrfCookie.split('=')

    return {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': cookieValue.trim(),
    }
}

export default appendHeaders
